import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../aws/AuthContext';

const API_URL = `${process.env.REACT_APP_API_URL}/v1-inventario`;

// 1. NUEVO: Hook para OBTENER el historial
export const useGetHistorialInventario = (fechaInicio, fechaFin) => {
  const { getJwtToken } = useAuth();
  
  return useQuery({
      queryKey: ['historial_inventario', fechaInicio, fechaFin],
      queryFn: async () => {
          const token = await getJwtToken();
          let url = API_URL;
          // Si el frontend envía fechas, las pegamos en la URL
          if (fechaInicio && fechaFin) {
              url += `?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`;
          }

          const res = await fetch(url, {
              method: "GET",
              headers: { Authorization: `Bearer ${token}` }
          });

          if (!res.ok) throw new Error('Error al cargar el historial');
          return res.json();
      },
      staleTime: 1000 * 60 * 2, // 2 minutos
  });
};

// 2. Hook para GUARDAR ajustes (Modificado para refrescar la tabla)
export const useAjustarInventario = () => {
  const queryClient = useQueryClient();
  const { getJwtToken } = useAuth();

  return useMutation({
    mutationFn: async (payload) => {
      const token = await getJwtToken();
      const res = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.error || 'Error desconocido del servidor');
      }
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productos'] });
      queryClient.invalidateQueries({ queryKey: ['historial_inventario'] });
      queryClient.invalidateQueries({ queryKey: ['stock_bodega'] });
      queryClient.invalidateQueries({ queryKey: ['bodegas'] });
    },
  });
};